// src/app/core/interceptors/api-prefix.interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const apiPrefixInterceptor: HttpInterceptorFn = (req, next) => {
  const updated = req.url.startsWith('http')
    ? req                                // absolute URL → leave as-is
    : req.clone({ url: `${environment.apiUrl}/${req.url}` });

  return next(updated);
};
